export default __webpack_public_path__ + "static/media/githublogo.79283b1a.png";